export default class ResetForm {
    constructor() {
        return {
            template: require('../../../../views/login/organisms/o-reset-form.html'),
            controller: ResetFormController,
            controllerAs: 'resetForm',
            bindings: {
                formFields: '=',
                backToLogin: '&'
            }
        }
    }
}

class ResetFormController {
    constructor($scope, $transitions, $element, $sanitize, $filter, ResetHandler) {
        this._scope = $scope;
        this._sanitize = $sanitize;
        this._translator = $filter('translate');
        this.resetHandler = ResetHandler;
        this.errorText = null;
        this.successText = null;

        $transitions.onStart({}, () => {
            this.backToLogin();
        })

        this.$onInit = () => {
            $element.addClass('o-login-form');
        }
    };

    doReset() {

        this.errorText = null;
        this.successText = null;

        let email = this._sanitize(this.formFields.email);

        this.resetHandler.doReset(email).then(() => {
            this.successText = this._translator('LOGIN:RESET-PASSWORD:SUCCESS_TEXT');
        }, (err) => {
            let errors = err.data.errors;
            console.log(err);
            this.errorText = errors ? Object.values(errors)[0][0] : this._translator('LOGIN:RESET-PASSWORD:ERROR_TEXT');
        })
    };
}

